import styled from 'styled-components';

export const FeedbackContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 16px 0px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  gap: 2rem;
  text-align: center;
`;

export const FeedbackText = styled.p`
  color: #283618;
  text-align: center:
`;

export const Emoji = styled.div`
  font-size: 64px;
  margin-bottom: 8px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: 1024px) {
    flex-direction: row;
    justify-content: center;
    gap: 24px;
  }
`;
